export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'kulanceBreadcrumbTODO';
export const NAME = 'Kulance';
export const PRACOVNI_POZICE = 'ZakazkaPracovniPozice';
export const ZAKAZKA_ND = 'ZakazkaNd';
export const SERVICE_JOB_DETAILS = 'ServiceJobDetails';
export const OwnerContactTypeId = 1;
